type StepCardProps = {
  num: string;
  title: string;
  description: string;
  badgeClass: string;
};

export default function StepCard({
  num,
  title,
  description,
  badgeClass,
}: StepCardProps) {
  return (
    <div className="text-center sm:text-left">
      <div className="flex items-center justify-center sm:justify-start">
        <span
          className={`flex items-center justify-center h-9 w-9 rounded-xl font-semibold ${badgeClass}`}>
          {num}
        </span>
      </div>
      <div className="mt-3">
        <div className="font-semibold text-gray-900">{title}</div>
        <p className="text-gray-600 text-sm sm:text-base mt-1 leading-relaxed text-balance">
          {description}
        </p>
      </div>
    </div>
  );
}
